// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__A0B1L","header__img":"styles_header__img___798E","header__body":"styles_header__body__dT0_O"};